module.exports = __webpack_public_path__ + "static/media/entering_chatham_small.b64e89e1.jpg";